import { connect } from "react-redux";
import { BlottingPaper as Component } from "./blottingPaper";

/**
 * Maps the Redux store's state to the props that the BlottingPaper component needs.
 * 
 * @param {Object} state - The entire Redux store's state.
 * @param {Object} ownProps - The props that are being passed to the BlottingPaper component.
 * 
 * @returns {Object} Object containing data to be passed as props to the BlottingPaper component.
 */
const mapStateToProps = (state, ownProps) => {
  let items = state.blottingPaper[ownProps.object_type];

  // If there are 5 items and the section is "RESULTS", skip the first item.
  if (items.length === 5 && ownProps.section === "RESULTS") {
    items = items.slice(1);
  }

  return {
    data: items
  };
};

// Connect the BlottingPaper component to the Redux store.
export const BlottingPaper = connect(mapStateToProps)(Component);
